/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
(function() {
    let touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      let moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});
  })();


/***
image switching
***/
let sliderHolders = document.getElementsByClassName("autoPlayImgSection");

Array.from(sliderHolders).forEach((holder, index) => {
  let images = holder.getElementsByClassName('AutoPlayImg');
  let currentImage = 0;
  
  images[parseInt(images.length / 5) + 1].getElementsByTagName('img')[0].onload=function(){
      setInterval(function() {
        images[currentImage % images.length].style.display = 'none';
        images[(currentImage + 1) % images.length].style.display = 'block';
        currentImage += 1;
      }, 1200);
  };
});


// Apple Cihazlar Modal
var appleModal = document.getElementById("appleSizeGuideModal");
var appleLink = document.getElementById("appleSizeGuideLink");
var appleCloseBtn = document.getElementsByClassName("close")[0];

// Diğer Cihazlar Modal
var otherModal = document.getElementById("otherSizeGuideModal");
var otherLink = document.getElementById("otherSizeGuideLink");
var otherCloseBtn = document.getElementsByClassName("close")[1];

// Apple Linke tıklandığında Apple modalı göster
appleLink.onclick = function() {
  appleModal.style.display = "block";
}

// Diğer Cihazlar Linke tıklandığında diğer modalı göster
otherLink.onclick = function() {
  otherModal.style.display = "block";
}

// Apple modalı kapatmak için (x) elementine tıkla
appleCloseBtn.onclick = function() {
  appleModal.style.display = "none";
}

// Diğer Cihazlar modalını kapatmak için (x) elementine tıkla
otherCloseBtn.onclick = function() {
  otherModal.style.display = "none";
}

// Kullanıcı modalın dışına tıkladığında modalı kapat
window.onclick = function(event) {
  if (event.target == appleModal) {
    appleModal.style.display = "none";
  } else if (event.target == otherModal) {
    otherModal.style.display = "none";
  }
}



